<template>
  <div class="event-container">
    <el-dropdown @command="dropdown">
      <el-button type="primary">
        添加事件<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="item.value" v-for="item in eventList">{{
          item.label
        }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button-group class="menu-group">
      <el-button
        icon="el-icon-copy-document"
        title="复制"
        size="mini"
        round
        @click="copyEvents(copyType.all)"
      ></el-button>
      <el-button
        round
        icon="el-icon-document-add"
        title="粘贴"
        size="mini"
        @click="pasteEvents()"
      ></el-button>
    </el-button-group>

    <el-collapse @change="handleChange" style="margin-top: 20px">
      <el-collapse-item
        :title="'事件 ' + (index + 1)"
        v-for="(item, index) in topo.data.spriteEvents"
      >
        <div class="event-properties-item">
          <div class="event-label">事件类型</div>
          <div>
            <el-select v-model="item.name" placeholder="请选择" size="mini">
              <el-option
                v-for="eventItem in eventList"
                :key="eventItem.value"
                :label="eventItem.label"
                :value="eventItem.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 添加action -->
        <template>
          <div class="event-properties-item">
            <div class="event-label">执行操作</div>
            <div>
              <el-select v-model="item.action" placeholder="请选择" size="mini">
                <el-option
                  v-for="eventItem in actions"
                  :key="eventItem.value"
                  :label="eventItem.label"
                  :value="eventItem.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 执行的行为 -->
          <div>
            <!-- 打开链接 -->
            <open-link
              v-if="item.action === EventAction.Link"
              :uuid="item.uuid"
              :technology="topo"
            ></open-link>
            <!-- 设置属性 -->
            <set-props
              v-if="item.action === EventAction.SetProps"
              :uuid="item.uuid"
              :technology="topo"
            ></set-props>

            <!-- 执行各种任务 -->
            <run-action
              v-if="showAction(item.action)"
              :actionType="item.action"
              :technology="topo"
              :uuid="item.uuid"
            ></run-action>

            <!-- 执行函数 -->
            <function-action
              v-if="item.action === EventAction.Function"
              :technology="topo"
              :uuid="item.uuid"
            ></function-action>

            <!-- 发送消息 -->
            <sendEvent
              v-if="item.action === EventAction.Emit"
              :technology="topo"
              :uuid="item.uuid"
            ></sendEvent>

            <!-- 全局函数 -->
            <globalFunc
              v-if="item.action === EventAction.WindowFn"
              :technology="topo"
              :uuid="item.uuid"
            ></globalFunc>
          </div>
        </template>
          <!-- <el-button
          size="mini"
          class="add-comparison-btn"
          @click="addActions(item)"
          >添加新的操作</el-button
        > -->
        
        <div class="event-execution-condition" v-if="item.where">
          <hr style="background-color: #ccc; height: 1px; border: none" />
          <div class="event-properties-item">
            <div class="event-label">属性</div>
            <div>
              <el-input size="mini" v-model="item.where.key"></el-input>
            </div>
          </div>
          <div class="event-properties-item">
            <div class="event-label">条件</div>
            <div>
              <el-select
                v-model="item.where.comparison"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="eventItem in comparison"
                  :key="eventItem.value"
                  :label="eventItem.label"
                  :value="eventItem.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="event-properties-item">
            <div class="event-label">属性值</div>
            <div>
              <el-input
                size="mini"
                v-model="item.where._value"
                @change="valType(item)"
              ></el-input>
            </div>
          </div>
        </div>

        <el-button
          size="small"
          class="add-comparison-btn"
          :type="!item.where ? 'primary' : 'danger'"
          @click="addcomparison(item)"
          >{{ !item.where ? "添加执行条件" : "取消条件执行" }}</el-button
        >
        <el-button
          size="small"
          class="add-comparison-btn"
          type="danger"
          @click="deleteEvent(index)"
          >删除</el-button
        >
        <el-button-group class="menu-group">
          <el-button
            icon="el-icon-copy-document"
            title="复制"
            size="mini"
            round
            @click="copyEvents(copyType.current, item)"
          ></el-button>
          <el-button
            round
            icon="el-icon-document-add"
            title="粘贴"
            size="mini"
            @click="pasteEvents"
          ></el-button>
        </el-button-group>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { eventType, EventAction, Comparison } from "../types/sprite-types";
import openLink from "./event/open-link.vue";
import setProps from "./event/set-props.vue";
import runAction from "./event/run-action.vue";
import functionAction from "./event/function-action.vue";
import sendEvent from "./event/send-event.vue";
import Core from "@/libs/src/core.js";
import globalFunc from "./event/globalFunc.vue";
import { uuid } from "@/libs/src/utils/tools.js";
import { valueType } from "../utils/dataDefine";

const copyType = {
  all: 0,
  current: 1,
};

export default {
  components: {
    openLink,
    setProps,
    runAction,
    functionAction,
    sendEvent,
    globalFunc,
  },
  data() {
    return {
      EventAction: EventAction,
      activeNames: ["1"],
      topo: "",
      propVal: "",
      copyType,
      actionList:[],//所有的操作列表
      eventList: [
        {
          label: "鼠标进入",
          value: eventType.enter,
        },
        {
          label: "鼠标离开",
          value: eventType.leave,
        },
        {
          label: "选中",
          value: eventType.active,
        },
        {
          label: "取消选中",
          value: eventType.inactive,
        },
        {
          label: "单击",
          value: eventType.click,
        },
        {
          label: "双击 ",
          value: eventType.dblclick,
        },
        {
          label: "鼠标按下",
          value: eventType.mousedown,
        },
        {
          label: "鼠标抬起",
          value: eventType.mouseup,
        },
        {
          label: "数据更新",
          value: eventType.valueUpdate,
        },
        {
          label: "初始化",
          value: eventType.init,
        },
        // {
        //   label: "监听消息",
        //   value: eventType.listener,
        // },
      ],
      events: [],
      comparison: [
        {
          label: "等于",
          value: Comparison.Equal,
        },
        {
          label: "不等于",
          value: Comparison.NotEqual,
        },
        {
          label: "大于",
          value: Comparison.GreaterThan,
        },
        {
          label: "小于",
          value: Comparison.LessThan,
        },
        {
          label: "大于等于",
          value: Comparison.GreaterThanOrEqual,
        },
        {
          label: "小于等于",
          value: Comparison.LessThanOrEqual,
        },
        {
          label: "包含",
          value: Comparison.Contains,
        },
        {
          label: "不包含",
          value: Comparison.NotContains,
        },
        {
          label: "介于之间",
          value: Comparison.Between,
        },
        {
          label: "不介于之间",
          value: Comparison.NotBetween,
        },
      ],
      actions: [
        {
          label: "打开链接",
          value: EventAction.Link,
        },
        {
          label: "更改属性",
          value: EventAction.SetProps,
        },
        {
          label: "执行动画",
          value: EventAction.StartAnimate,
        },
        {
          label: "暂停动画",
          value: EventAction.PauseAnimate,
        },
        {
          label: "停止动画",
          value: EventAction.StopAnimate,
        },
        {
          label: "播放视频",
          value: EventAction.StartVideo,
        },
        {
          label: "暂停视频",
          value: EventAction.PauseVideo,
        },
        {
          label: "停止视频",
          value: EventAction.StopVideo,
        },
        // {
        //   label: "执行函数",
        //   value: EventAction.Function,
        // },
        {
          label: "执行全局函数",
          value: EventAction.WindowFn,
        },
        {
          label: "发送自定义消息",
          value: EventAction.Emit,
        },
      ],
    };
  },

  created() {
    this.topo = Core.getProvider("TechnologyTopo");

    this.init();
  },
  methods: {
    // 添加新的actions
    addActions(eventItem){
      let obj = {
        action: "", // 执行动作
        value: "", // 属性值
        params: "", //参数名
      }
      this.actionList.push(obj);
    },
    valType(item) {
      // 转换数据类型
      item.where.value = valueType(item.where._value);
    },
    showAction(eventType) {
      if (
        eventType == EventAction.StartAnimate ||
        eventType == EventAction.PauseAnimate ||
        eventType == EventAction.StopAnimate ||
        eventType == EventAction.StartVideo ||
        eventType == EventAction.PauseVideo ||
        eventType == EventAction.StopVideo
      ) {
        return true;
      }
      return false;
    },
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.bindData(this.topo.store.active[0]);
      } else {
        this.topo.data.spriteEvents = [];
      }
      this.events = this.topo.data.spriteEvents;
      // this.active = this.topo.store ? this.topo.store.active : [];
    },
    bindData(active) {
      this.topo.data.spriteEvents = active.events || [];
    },
    // 添加条件执行
    addcomparison(item) {
      if (!item.where) {
        item.where = { key: "", comparison: "", value: "" };
      } else {
        item.where = null;
      }
    },
    // 选择添加的事件类型
    dropdown(command) {
      let eventObject = {
        uuid: uuid(),
        name: command,
        action: "", // 执行动作
        where: null, // 触发条件
        value: "", // 属性值
        params: "", //参数名
      };
      // 如果是自定义监听事件
      /* if(command === this.eventType.listener){

      } */
      this.topo.data.spriteEvents.push(eventObject);
    },
    handleChange(val) {
      console.log(val);
    },
    getAction(uuid) {
      let action = this.events.find((item) => item.uuid == uuid);
      return action;
    },
    // 删除已添加的事件
    deleteEvent(index) {
      this.topo.data.spriteEvents.splice(index, 1);
    },
    // 复制事件
    copyEvents(type, event) {
      if (!this.topo.data.spriteEvents || !this.topo.data.spriteEvents.length)
        return;
      if (type == copyType.all) {
        this.topo.data.copyEvents = JSON.parse(
          JSON.stringify(this.topo.data.spriteEvents)
        ).map((item) => {
          item.uuid = uuid();
          return item;
        });
      } else {
        // 更新uuid
        let _event = JSON.parse(JSON.stringify(event));
        _event.uuid = uuid();
        this.topo.data.copyEvents = [_event];
      }
      this.$message("已复制事件");
    },
    // 粘贴
    pasteEvents() {
      let events = this.topo.data.copyEvents.map(item=>{
        item.uuid = uuid();
        return item;
      });
      if (events.length) {
        this.topo.data.spriteEvents =
          this.topo.data.spriteEvents.concat(events);
        this.$message("已粘贴事件");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.event-container {
  height: calc(100vh - 170px);
  overflow-y: auto;
}
.event-properties-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .event-label {
    width: 120px;
  }
}
.add-comparison-btn {
  margin-top: 15px;
}
.menu-group {
  margin-left: 25px;
}
</style>